import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';

interface HotelPricingAssistantExceptionIndicatorSignature {
  Args: {};
}

const HotelPricingAssistantExceptionIndicator: TOC<HotelPricingAssistantExceptionIndicatorSignature> =
  <template>
    <PrismIcon
      @color="critical"
      @name="circle-minus"
      @size="small"
      data-test-id="exception-icon"
    />
  </template>;

export default HotelPricingAssistantExceptionIndicator;
